export default "__VITE_ASSET__9fd45886__"